<template>
  <div class="loan-list">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="查谱文档教程"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!--详情-->
    <div>
      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="100%"
               height="100%"
               :src="require('../../../public/static/p1.png')"
             />
          </div>
        </div>

        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="100%"
               height="100%"
               :src="require('../../../public/static/p2.png')"
             />
          </div>
        </div>

        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="100%"
               height="100%"
               :src="require('../../../public/static/p3.png')"
             />
          </div>
        </div>

        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="100%"
               height="100%"
               :src="require('../../../public/static/p4.png')"
             />
          </div>
        </div>

        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="100%"
               height="100%"
               :src="require('../../../public/static/p5.png')"
             />
          </div>
        </div>

        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="100%"
               height="100%"
               :src="require('../../../public/static/p6.png')"
             />
          </div>
        </div>
      </div>

    </div>

    </div>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'LoanList',
    data() {
        return {

        };
    },
    computed: {
      ...mapState({
          detail: state => state.root.clan_detail
      })
    },
    methods: {
      ...mapActions(['requestClanShow']),
      onClickLeft() {
          this.$router.push({path: '/home'});
      }
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.loan-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ed3f2c;
  padding-top: 6px;
}
.loan-list >>> .van-nav-bar__text {
  color: #fff;
}
.loan-list >>> .van-nav-bar__title {
  color: #fff;
}
.loan-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.loan-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}
</style>
